import { render, staticRenderFns } from "./TreeDiaryItemShare.vue?vue&type=template&id=63d46e96&"
import script from "./TreeDiaryItemShare.vue?vue&type=script&lang=ts&"
export * from "./TreeDiaryItemShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports